import { Inject, Injectable } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { SZZA012AService, Szza012aRequest, Szza012aResponse } from 'sg-api';
import { FeaturesLibConfig } from '../../../config/features-lib-config';
import { FEATURES_LIB_CONFIG } from '../../../config/features-lib-config.token';

@Injectable({
  providedIn: 'root'
})
export class UsedSzza012aService {

  /**
   * コンストラクタ
   * @param {Szza012aService} sgke092aService
   * @param {ApiCommonService} apiCommonService
   * @param {FeaturesLibConfig} featuresLibConfig
   * @memberof UsedSzza012aService
   */
  constructor(
    private service: SZZA012AService,
    private apiCommonService: ApiCommonService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }

  /**
   * 業務日付取得API呼び出し
   * @param {Szza012aRequest} request
   * @return {*}  {Observable<Szza012aResponse>}
   * @memberof UsedSzza012aService
   */
  public doSzza012a(request: Szza012aRequest): Observable<Szza012aResponse> {

    return this.service.a10RSZZA012APost(this.apiCommonService.setRequestCommon(request), 'response')
      .pipe(
        map(
          response => {
            // エラーが設定されていないかチェックし、エラーの場合catchError()に処理が移る
            this.apiCommonService.checkError(response);
            return response.body;
          }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SZZA012A');
          return throwError(err.message);
        })
      );
  }
}
